import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';
const sendVisitPath = async (values: {
  label: string;
  origin: string;
  time?: boolean;
  device_code?: string;
}) => {
  const authToken = getCookie(authKeys.authToken);
  const urlSendClick = !authToken ? apiConfig.routes.customer.sendVisitPublic : apiConfig.routes.customer.sendVisit;
  await api.post(urlSendClick, values);
};
export const useSendVisitPath = () => {
  return useMutation({
    mutationFn: sendVisitPath
  });
};